import { forwardRef, useEffect, useState } from "react";
import { Input } from 'reactstrap';

import './Switch.css'

const CustomCheckBox = forwardRef((props, ref) => {
    let [checked, updateChecked] = useState(props.checked);
    let className = '';

    const handleChange = element => {
        updateChecked(element.target.checked);
        props.onChange(element);
    };

    useEffect(() => {
        updateChecked(props.checked);
    }, [props.checked]);


    if (props.error) {
        className = "is-invalid";
    }

    return (
        <div className={props.switch ? "d-flex align-items-center" : ""}>
            {props.switch && (
                <label className="m-0" htmlFor={'id_' + props.name} >
                    {props.label}
                </label>)
            }
            <div className={`${props.disabled && " wrapper__switch__disabled"}`}>
                <label className={`${props.switch && "switch m-0 ml-2"} ${props.disabled && " switch__disabled"}`}>
                    <Input
                        id={'id_' + props.name}
                        onChange={handleChange}
                        className={className}
                        type="checkbox"
                        name={props.name}
                        checked={checked}
                        ref={ref}
                        disabled={props.readOnly}
                        autoFocus={props.autoFocus ? true : false}
                        style={props.name === "Ações" ? { marginLeft: "0.8rem", ...props.style } : { ...props.style }}
                    />
                    {props.switch ? (
                        <span class="slider round"></span>
                    ) : (
                        props.label
                    )}
                    {props.required && (
                        <span className="required"> *</span>
                    )}
                    {props.error && (
                        <span
                            class="error invalid-feedback"
                            style={{ display: 'inline', marginLeft: '10px' }}>
                            {props.error}
                        </span>
                    )}
                </label>
            </div>
        </div>
    );
})
export default CustomCheckBox;